import { createContext } from 'react';
import { defaultCommentsProps } from './constants';
export const CommentsPropsContext = /*#__PURE__*/createContext(defaultCommentsProps);